import React, { useMemo } from "react";
import Typography from "../../Typography";
import styles from "./copyright.module.scss";

const Copyright = () => {
    const startYear = 2026;
    const copyrightYear = useMemo(() => {
        const currentYear = new Date().getFullYear();
        return `${startYear}${startYear < currentYear ? ` - ${currentYear}` : ""}`;
    }, []);

    return (
        <Typography className={styles.root} variant="body2">
            {`COPYRIGHT BLAGO \u00A9 ${copyrightYear}`}
        </Typography>
    );
};

export default Copyright;